import label from '../../assets/i18n/en.json'
const AdminMenu =
    [
    { title: 'Practice Management', path: '', icon: 'user plus' },
        // { title: 'Dashboard', path: '', icon: 'home' },
        // { title: 'Facility Management', path: 'facility-management', icon: 'hospital outline' },
        // { title: 'Practice Management', path: 'practice-management', icon: 'user plus' },
        // { title: 'Report', path: 'report', icon: 'chart bar' },
        { title: 'Form Management', path: 'forms', icon: 'pencil' },
        // { title: 'Equipment Type', path: 'equipment-type', icon: 'cog' },
    ]

export default AdminMenu